
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import { PaymentMethodsSection } from '@/types/billing-types';

export default defineComponent({
  name: 'PaymentMethodsPanel',

  components: { Button },

  props: {
    paymentMethods: {
      type: Object as PropType<PaymentMethodsSection>,
      required: true,
    },
    /**
     * Token id that just became default — flashes a brand-colour pulse to
     * draw the eye to the new default after the list reorders. The parent
     * clears this back to `null` ~1.4s later.
     */
    recentlyDefaultedId: {
      type: String as PropType<string | null>,
      default: null,
    },
  },

  emits: ['add', 'set-default', 'delete'],

  setup() {
    const { t } = useI18n();

    const brandIcon = (brand: string): string => {
      const b = (brand ?? '').toLowerCase();
      if (b.includes('visa')) return 'fa-brands fa-cc-visa';
      if (b.includes('master')) return 'fa-brands fa-cc-mastercard';
      if (b.includes('amex')) return 'fa-brands fa-cc-amex';
      if (b.includes('discover')) return 'fa-brands fa-cc-discover';
      return 'fa-regular fa-credit-card';
    };

    return { t, brandIcon };
  },
});
